import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import {
  STORY_SENTENCE_WORDS_MAX,
  STORY_SENTENCES_MAX,
  storyOverBudget,
} from '@platform/schema/generation';

import type { LessonWorkspace } from '@platform/schema/review';

type Sentence = LessonWorkspace['storySentences'][number];

/**
 * The extra module-story sentences the lesson holds, each with its scene — GEN-131. The
 * ones past the budget are marked, which is what approving waits on.
 */
export function StorySentences({
  sentences,
}: {
  sentences: readonly Sentence[];
}) {
  if (sentences.length === 0) return null;

  const { extra, long } = storyOverBudget(sentences);
  const over = new Set([...extra, ...long]);

  return (
    <Paper variant="outlined" sx={{ p: 2 }} data-testid="story-sentences">
      <Stack spacing={1}>
        <Typography variant="subtitle2">
          Story sentences: {sentences.length} of {STORY_SENTENCES_MAX}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          At most {STORY_SENTENCES_MAX} a lesson, each at most{' '}
          {STORY_SENTENCE_WORDS_MAX} words. The lesson cannot be approved past
          either.
        </Typography>
        {sentences.map((one) => (
          <Stack key={`${String(one.position)} ${one.sentence}`}>
            <Typography
              variant="caption"
              color={over.has(one) ? 'error' : 'text.secondary'}
            >
              Scene {one.position} · {one.field}
              {over.has(one) ? ' · over the limit' : ''}
            </Typography>
            <Typography variant="body2">“{one.sentence}”</Typography>
          </Stack>
        ))}
      </Stack>
    </Paper>
  );
}
